<template>
  <div class="molecule-select-equipment_container">
    <atom-checkbox
      class="select-equipment__select-all--checkbox"
      v-model="isCheckedAll"
      :isDisable="!listData.length"
      title="Select All"
      textStyle="font-weight:600;font-size:12px"
    ></atom-checkbox>
    <div v-if="listData.length" class="equipment-list_container">
      <div
        class="select-equipment__equipment-list"
        v-for="(equipment, index) in listData"
        :key="index"
      >
        <div
          class="select-equipment__equipment--bg"
          :class="{
            'select-equipment__equipment-list--selected': equipment.isSelected,
          }"
          @click="selectEquipment(equipment)"
        ></div>
        <div
          v-if="equipment.isSelected"
          :class="{
            'select-equipment__equipment-list--line': equipment.isSelected,
          }"
        ></div>
        <div class="select-equipment__equipment-list--item">
          <atom-checkbox v-model="equipment.isChecked"></atom-checkbox>
          <span
            class="select-equipment__equipment--name"
            :class="{
              'select-equipment__text--primary': equipment.isChecked,
            }"
            @click="selectEquipment(equipment)"
            >{{ equipment.name }}</span
          >
        </div>
      </div>
    </div>
    <div v-else class="no-equipment-message__container">
      <span>No matching equipment.</span>
    </div>
  </div>
</template>

<script>
import AtomCheckbox from "@/components/atoms/AtomCheckbox.vue"
export default {
  name: "MoleculeSelectEquipment",
  components: {
    AtomCheckbox,
  },
  props: {
    listData: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  emits: ["checkedListData", "selectedData"],
  data() {
    return {
      isCheckedAll: false,
      checkedList: null,
      selectedEquipment: null,
      isInitialCheck: true,
    }
  },
  watch: {
    isCheckedAll() {
      this.toggleCheck()
    },
    listData: {
      deep: true,
      handler() {
        this.addCheckedEquipmentList()
        this.initialSelectEquipment()
      },
    },
  },

  methods: {
    toggleCheck() {
      if (
        this.isCheckedAll &&
        this.checkedList.length !== this.listData.length
      ) {
        for (var i = 0; i < this.listData.length; i++) {
          this.listData[i].isChecked = true
        }
      }
      if (
        !this.isCheckedAll &&
        this.checkedList.length === this.listData.length
      ) {
        for (var i = 0; i < this.listData.length; i++) {
          this.listData[i].isChecked = false
        }
      }
    },
    addCheckedEquipmentList() {
      this.checkedList = []
      for (var i = 0; i < this.listData.length; i++) {
        if (this.listData[i].isChecked) {
          this.checkedList.push(this.listData[i])
        }
        if (this.checkedList.length === this.listData.length) {
          this.isCheckedAll = true
        } else {
          this.isCheckedAll = false
        }
      }
      this.$emit("checkedListData", this.checkedList)
    },
    selectEquipment(equipment) {
      this.selectedEquipment = equipment
      this.$emit("selectedEquipment", this.selectedEquipment)
    },
    initialSelectEquipment() {
      if (this.listData.length !== 0 && this.isInitialCheck) {
        this.isInitialCheck = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.select-equipment__select-all--checkbox {
  margin-bottom: 5px;
  margin-left: 15px;
  margin-right: 15px;
}

.select-equipment__equipment-list {
  display: flex;
  position: relative;
  align-items: center;
  height: 36px;
  padding-left: 15px;
  padding-right: 15px;
  &:hover {
    cursor: pointer;
  }
}

.select-equipment__equipment-list--item {
  display: flex;
  position: absolute;
  &:hover {
    cursor: pointer;
  }
}

.select-equipment__equipment-list--selected {
  background-color: #eeedfd;
}

.select-equipment__equipment-list--line {
  position: absolute;
  left: 0;
  content: none;
  height: 100%;
  border-left: 4px solid #7367f0;
  border-radius: 5px;
}

.select-equipment__text--primary {
  color: #7367f0;
  font-weight: 500;
}

.select-equipment__equipment--bg {
  content: none;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 0;
}

.equipment-list_container {
  height: 250px;
  overflow-y: auto;
}

.no-equipment-message__container {
  text-align: center;
}

// Medium devices (tablets, 768px and up)
@media screen and (min-width: 768px) {
  .equipment-list_container {
    height: 325px;
    overflow-y: auto;
  }
}

@media screen and (min-width: 992px) {
  .equipment-list_container {
    height: calc(100vh - 28rem);
    overflow-y: auto;
  }
}
</style>
